<p-accordionTab>
  <p-header>
    <span class="pull-left">{{ itemType | commercialImpactItemType }}</span>
    <span class="pull-right">{{'CommercialImpactItem.Total' | i18next : {value:getTotalCostsSum()} }}</span>
  </p-header>
  <hb-commercial-impact-inputs [isReadOnly]="isReadOnly" [isProductionTable]="isProduction" [form]="form"
    [itemType]="itemType"></hb-commercial-impact-inputs>
</p-accordionTab>
